exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image__3Ts8X{-webkit-animation:imageFadeIn__3wUm1 4s ease;animation:imageFadeIn__3wUm1 4s ease;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.image__3Ts8X:before{top:0;height:100%;background-color:#fff}.image__3Ts8X:after,.image__3Ts8X:before{content:\" \";display:block;position:absolute;left:0;width:100%}.image__3Ts8X:after{font-size:16px;font-style:normal;top:5px;text-align:center}.loading__3W6_K{opacity:0}.image__3Ts8X[cached]{-webkit-animation:none;animation:none;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@-webkit-keyframes imageFadeIn__3wUm1{0%{opacity:0}to{opacity:1}}@keyframes imageFadeIn__3wUm1{0%{opacity:0}to{opacity:1}}", ""]);

// exports
exports.locals = {
	"image": "image__3Ts8X",
	"imageFadeIn": "imageFadeIn__3wUm1",
	"loading": "loading__3W6_K"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-1!../node_modules/postcss-loader/lib??postcss!./components/image/style.css
// module id = HzbK
// module chunks = 31